<template>
  <header class="main-header">
    <picture class="main-header-logo" v-if="$i18n.locale === 'zh'">
      <source srcset="/logo.webp" type="image/webp">
      <img src="/logo.jpg" alt="logo"></img>
    </picture>
    <picture class="main-header-logo" v-else>
      <source srcset="/logo-en.webp" type="image/webp">
      <img src="/logo-en.jpg" alt="logo"></img>
    </picture>
    <div class="header-right">
      <div class="slot-left">
        <slot name="header-left"></slot>
      </div>
      <lang-select></lang-select>
      <div class="slot-right">
        <slot name="header-right"></slot>
      </div>
    </div>
  </header>
</template>

<script>

import LangSelect from "@/components/lang-select/index.vue";

export default {
  name: 'MainHeader',
  components: {LangSelect},
  props: {},
  data() {
    return {
    }
  },

}

</script>

<style scoped lang="scss">
.main-header {
  padding: 6px 16px;
  display: grid;
  grid-template-columns: 200px calc(100% - 200px);
  height: 60px;
  background-color: transparent;
  color: #ffffff;

  &-logo{
    align-self: center;
    height: 32px;
    >img{
      display: block;
      height: 100%;
    }
  }
  .header-right {
    padding-right: 15px;
    align-self: center;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
  }
  .slot-right{
    width: max-content;
  }
}
</style>
